export default {
  plano: state => state.plano,
  cliente: state => state.cliente,
  fatura: state => state.fatura
}
